import React, {useContext} from "react";
import {ReactKeycloakProvider} from "@react-keycloak/web";
import Keycloak from "keycloak-js";
import axiosInstance from "../../../common/src/api/AxiosInstance";
import {UserContext} from "../context/UserContext"
import {useNavigate} from "react-router-dom";
import PromiseBuilder from "common/src/utils/PromiseUtils";
import apiClient from "common/src/api/ApiClient";

const keycloak = new Keycloak({
  url: "/auth",
  realm: 'saoe',
  clientId: 'booking-ui'
});

const Auth = (props) => {
  const { setUser } = useContext(UserContext);

  const initialOptions = {
    onLoad: 'login-required',
    pkceMethod: 'S256',
    enableLogging: true,
    checkLoginIframe: false,
    checkLoginIframeInterval: 10
  }

  const onTokens = (tokens) => {

    const userData = {
      id: keycloak.tokenParsed.sub,
      firstName: keycloak.tokenParsed.given_name,
      lastName: keycloak.tokenParsed.family_name,
      hasLoaded: false,
    }

    axiosInstance.setAuthToken(tokens.token);

    fetchCompanyData(userData, keycloak.tokenParsed.companyId)
    setUser(userData);
  }

  function fetchCompanyData(userData, companyId) {
    if (typeof companyId === "undefined") {
      setUser({
        ...userData,
        hasLoaded: true
      });
      return;
    }
    new PromiseBuilder()
      .then(() => apiClient.get(`/api/v1/company/${companyId}`))
      .then((res) => {
        const data = res.data.payload;
        setUser({
          ...userData,
          companyName: data.name,
        })
      })
      .catch(() => navigate("account-error"))
      .run();
  }

  return (
    <ReactKeycloakProvider
      authClient={keycloak}
      initOptions={initialOptions}
      LoadingComponent={<div/>}
      isLoadingCheck={() => !keycloak.authenticated}
      onTokens={onTokens}>
      {props.children}
    </ReactKeycloakProvider>)
}

export default Auth;
